import { getCountryCodes } from './requests';

export default {
  getCountryCodes,
};
